module.exports = __webpack_public_path__ + "static/media/address-search-success.11499e4f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/message/address-search-success.svg
 ** module id = 1324
 ** module chunks = 0
 **/